import { Component } from '@angular/core';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { Alert } from '../../models/Alert';
import { AlertService } from '../../services/alert.service';
import { FormsModule } from '@angular/forms';
declare var bootstrap: any;

@Component({
    selector: 'app-configurations-customer',
    templateUrl: './configurations-customer.component.html',
    styleUrls: ['./configurations-customer.component.css'],
    imports: [FormsModule]
})
export class ConfigurationsCustomerComponent {
  selectedValue: number = 50; // Valor inicial del control de rango (entre 50 y 100)
  userDto: UserDTO  = {} as UserDTO;
  alert: Alert = {} as Alert;

  constructor(
    private customerService: CustomerService,
    private alertService: AlertService,
  ) {}

  ngOnInit() {
    // this.customerService.getPercentageAlertByUser().subscribe(
    //   ({ StatusCode, Message, Data }) => {
    //     if (Data != null) {
    //       this.HandleGetCustomer(Data);
    //     } else {
    //       this.HandleGetCustomerError(StatusCode);
    //     }
    //   },
    //   (error) => {
    //     this.alert = {
    //       alertMessage: 'Unexpected error. Please try again later.',
    //       alertType: 'alert alert-danger',
    //       alertCenter: false,
    //       alerTitle: '',
    //       duration: 3000
    //     };
    //     this.alertService.updateAlertState(
    //       this.alert
    //     );
    //   }
    // );
  }

  HandleGetCustomer(customer: UserDTO) {
    this.selectedValue = customer.alertSendPercentage ?? 50;
    this.userDto = customer;
  }  

  HandleGetCustomerError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }


  // Método para abrir el modal
  openModal(): void {
    const modalElement = document.getElementById('configurationsModal');
    if (modalElement) {
      const modalInstance = new bootstrap.Modal(modalElement);
      modalInstance.show();
    }
  }

  // Método para cerrar el modal y limpiar backdrop
  closeModal(): void {
    const modalElement = document.getElementById('configurationsModal');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide(); // Cerrar el modal
      }
    }

    // Asegurarse de que el fondo oscuro (backdrop) se elimina
    const modalBackdrop = document.querySelector('.modal-backdrop');
    if (modalBackdrop) {
      modalBackdrop.remove(); // Remover el fondo oscuro manualmente
    }

    // También asegurarnos de que se elimine la clase `modal-open` del body
    document.body.classList.remove('modal-open');
  }

  // Método para actualizar el valor del rango
  updateValue(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.selectedValue = Number(inputElement.value); // Actualiza el valor seleccionado
  }

  updateUserStatus() {

    // this.userDto.alertSendPercentage = this.selectedValue;
    //   this.customerService
    //     .updateUserPercentageAlert(this.userDto)
    //     .subscribe(
    //       ({ StatusCode, Message, Data }) => {
    //         if (Data != null) {
    //           this.HandleUpdate(Data);
    //         } else {
    //           this.HandleUpdateError(StatusCode);
    //         }
    //       },
    //       (error) => {
    //         this.alert = {
    //           alertMessage: 'Unexpected error. Please try again later.',
    //           alertType: 'alert alert-danger',
    //           alertCenter: false,
    //           alerTitle: '',
    //           duration: 3000
    //         };
    //         this.alertService.updateAlertState(
    //           this.alert
    //         );
    //       }
    //     );

    //     this.closeModal();
  }

  async HandleUpdate(customer: boolean) {
		this.alert = {
      alertMessage: 'Configurations updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
  }

  HandleUpdateError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }
}
